import { faCalendarDay, faClock, faPlayCircle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { SpaceBlocking } from 'components/SpaceBooking/types';
import { refTable } from 'components/TrainingPlan/TrainingPlanHelpers';
import moment from 'moment';

interface Props {
    blocking: SpaceBlocking;
}

export const SpaceBlockingDatesComponent = ({ blocking }: Props) => {
    const start = moment(blocking.start);
    const repeat_until = moment(blocking.repeat_until);

    return (
        <div className="tw-grid tw-grid-cols-[auto_1fr] tw-items-center tw-gap-x-5 tw-gap-y-1">
            <span className="tw-leading-4 tw-text-accents-8">
                <FontAwesomeIcon size="xs" icon={faPlayCircle} />
            </span>
            <p className="tw-font-size-[0.875em] tw-m-0 tw-text-accents-8">
                {`${start.format('ddd')} ${start.format('l')} ${
                    blocking.repeat_until ? ` bis ${repeat_until.format('ddd')} ${repeat_until.format('l')}` : ''
                }`}
            </p>
            {blocking.repeat_period && (
                <>
                    <span className="tw-leading-4 tw-text-accents-8">
                        <FontAwesomeIcon size="xs" icon={faCalendarDay} />
                    </span>
                    <p className="tw-font-size-[0.875em] tw-m-0 tw-text-accents-8">{blocking.repeat_period}</p>
                </>
            )}
            <span className="tw-leading-4 tw-text-accents-8">
                <FontAwesomeIcon size="xs" icon={faClock} />
            </span>
            <p className="tw-font-size-[0.875em] tw-m-0 tw-text-accents-8">{`${refTable.times[blocking.start_time]} bis ${refTable.times[blocking.end_time]}`}</p>
        </div>
    );
};
